import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class LayoutCardSize extends BaseOption {
  static userInterfaceComponent = {
    label: "Card Type",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 15,
      options: [
        {
          label: "Small",
          value: "small",
        },
        {
          label: "Large",
          value: "large",
        },
      ],
    },
  };

  static defaultValue = "small";
}
